/**
 * Google Fonts CSS2 family params for names used in template.json (fontFamilyP, etc.).
 * Add new entries when a project uses another Google Font in the template.
 */
const GOOGLE_FONT_PARAMS = {
  Inter: 'family=Inter:wght@300;400;500;600;700;800',
  Oxanium: 'family=Oxanium:wght@200;300;400;500;600;700;800',
  Saira: 'family=Saira:wght@300;400;500;700;900',
  'Saira Condensed': 'family=Saira+Condensed:wght@400;500;600;700;800',
  Oswald: 'family=Oswald:wght@200;300;400;500;600',
  'Open Sans': 'family=Open+Sans:wght@300;400;600;700;800',
}

const LINK_ID = 'template-google-fonts'

function collectFontNames(template) {
  if (!template) return []
  return [
    template.fontFamilyP,
    template.fontFamilyH1,
    template.fontFamilyTitles,
    template.fontFamilyGeneral,
  ].filter(Boolean)
}

/**
 * Maps template font names (e.g. Inter-Regular) to Google Fonts family keys.
 */
export function resolveGoogleFontFamilyKey(name) {
  if (!name) return null
  if (GOOGLE_FONT_PARAMS[name]) return name
  if (/^Inter/i.test(String(name))) return 'Inter'
  if (/^SairaCondensed/i.test(String(name))) return 'Saira Condensed'
  if (/^Saira/i.test(String(name))) return 'Saira'
  return null
}

/**
 * CSS font-family stack for template font names.
 */
export function cssFontFamilyValue(name) {
  if (!name) return name

  const googleKey = resolveGoogleFontFamilyKey(name)
  if (googleKey) {
    const family = googleKey.includes(' ') ? `"${googleKey}"` : googleKey
    return `${family}, sans-serif`
  }

  const family = name.includes(' ') ? `"${name}"` : name
  return `${family}, sans-serif`
}

/**
 * Font weight hint from template names like Inter-Regular / Inter-Bold.
 */
export function cssFontWeightValue(name) {
  if (!name) return null
  const normalized = String(name).toLowerCase()
  if (normalized.includes('bold')) return '700'
  if (normalized.includes('medium')) return '500'
  if (normalized.includes('light')) return '300'
  if (normalized.includes('regular')) return '400'
  return null
}

/**
 * Injects/updates a single Google Fonts stylesheet for families declared in the template.
 */
export function loadGoogleFontsFromTemplate(template) {
  const names = [
    ...new Set(collectFontNames(template).map(resolveGoogleFontFamilyKey).filter(Boolean)),
  ]
  const params = names.map(name => GOOGLE_FONT_PARAMS[name]).filter(Boolean)

  if (params.length === 0) return

  const href = `https://fonts.googleapis.com/css2?${params.join('&')}&display=swap`
  let link = document.getElementById(LINK_ID)

  if (!link) {
    link = document.createElement('link')
    link.id = LINK_ID
    link.rel = 'stylesheet'
    document.head.appendChild(link)
  }

  link.href = href
}
